import { render, staticRenderFns } from "./StatisticalItem.vue?vue&type=template&id=652330fe&scoped=true&"
import script from "./StatisticalItem.vue?vue&type=script&lang=js&"
export * from "./StatisticalItem.vue?vue&type=script&lang=js&"
import style0 from "./StatisticalItem.vue?vue&type=style&index=0&id=652330fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652330fe",
  null
  
)

export default component.exports